import React from 'react';
import { useScoreboard } from './context/ScoreboardContext';
import { useDashboardLanguage } from './context/DashboardLanguageContext';

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

const TeamInferiority = ({ isLiveView = false }) => {
  const { t } = useDashboardLanguage();
  const {
    homeInferiorityEntries,
    awayInferiorityEntries,
    calculateInferiorityTime,
    showTeamInferiority,
    backgroundColor,
    centralTick // Use centralTick to trigger re-renders for countdown
  } = useScoreboard();

  // Calculate current inferiority times from entries
  const homeTeamInferiorityTime = calculateInferiorityTime(homeInferiorityEntries);
  const awayTeamInferiorityTime = calculateInferiorityTime(awayInferiorityEntries);

  // Don't render if feature is disabled
  if (!showTeamInferiority) {    
    return null;
  }

  // LiveView - show as two columns matching PersonalPenalties style
  if (isLiveView) {
    return (
      <div className="pb-[1vh]">
        <hr></hr>
        <div className="text-white text-[3vh] font-bold text-center">{t('teamInferiority')}</div>
        <div className="grid grid-cols-2 gap-[2vh]" style={{ backgroundColor }}>
        {/* Home Team Inferiority Time */}
        <div className="flex items-center justify-end w-full leading-tight whitespace-nowrap">
          <span className="text-[5vh] font-bold text-white font-chivo leading-none">
            {homeTeamInferiorityTime > 0 ? formatTime(homeTeamInferiorityTime) : ''}
          </span>
        </div>
        
        {/* Away Team Inferiority Time */}
        <div className="flex items-center justify-start w-full leading-tight whitespace-nowrap">
          <span className="text-[5vh] font-bold text-white font-chivo leading-none">
            {awayTeamInferiorityTime > 0 ? formatTime(awayTeamInferiorityTime) : ''}
          </span>
        </div>
      </div>
      </div>
    );
  }

  // Control Panel View
  return (
    
    <div>
      {/* PENALTIES Header */}
      <div className="grid grid-cols-[1fr,1fr] gap-[1vh] max-w-[40vh] mx-auto">
        {/* Home Team Inferiority Time */}
        <div className="flex flex-col items-center">
          <div className="text-[1.8vh] font-bold text-white mb-[0.5vh]">HOME</div>
          <div className="w-[12vh] h-[4vh] bg-white rounded border border-gray-300 flex items-center justify-center shadow-sm">
            <span className="text-[2.2vh] font-bold text-red-600">
              {homeTeamInferiorityTime > 0 ? formatTime(homeTeamInferiorityTime) : '--:--'}
            </span>
          </div>
        </div>
        
        {/* Away Team Inferiority Time */}
        <div className="flex flex-col items-center">
          <div className="text-[1.8vh] font-bold text-white mb-[0.5vh]">AWAY</div>
          <div className="w-[12vh] h-[4vh] bg-white rounded border border-gray-300 flex items-center justify-center shadow-sm">
            <span className="text-[2.2vh] font-bold text-red-600">
              {awayTeamInferiorityTime > 0 ? formatTime(awayTeamInferiorityTime) : '--:--'}
            </span>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default TeamInferiority;
